const paths = {
    verifyrequest: 'api/v3/requests/verify_request',
    upload_records: 'api/v3/requests/upload_records',
    move_request_to_priced: 'api/v3/requests/move_to_priced'
}

export default paths;
